import { render, staticRenderFns } from "./RequestPayments.vue?vue&type=template&id=3f31b0c0"
import script from "./RequestPayments.vue?vue&type=script&lang=js"
export * from "./RequestPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports